<template>
  <div>
    <Assessment/>
  </div>
</template>

<script>
import Assessment from "@/components/Assessment.vue";
export default {
  name: "AssessmentView",
  components: {
    Assessment
  }
};
</script>

